<app-image-file *ngIf="fileName" [fileUrl]="fileUrl" [height]="height"></app-image-file>
